"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var merge_1 = require("./merge");
var ArrayStrategy_1 = require("./Constants/ArrayStrategy");
exports.ArrayStrategy = ArrayStrategy_1.default;
exports.default = merge_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Volumes/Eoo/Repositories/legance/wp-content/themes/legance/node_modules/helpful-merge/dist/index.js
// module id = 1
// module chunks = 0